import React from "react";

import { Box, OriginLogo, TrackedLink } from "@origin-digital/ods-core";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@origin-digital/ods-types";
import styled from "styled-components";
import { navigationBarHeight } from "./helpers/consts";
import { IKrakenAuthNavProps } from "./interfaces";

const StyledContainer = styled(Box)(() => ({
  paddingRight: 5,
  height: navigationBarHeight,
  paddingLeft: 0,
  width: 116,
  display: "flex",
  alignItems: "center",
}));

interface ISmallerLogo extends IKrakenAuthNavProps {
  href: string;
  id: string;
}

const SmallerLogo = ({ href, id }: ISmallerLogo) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("lg")
  );

  return (
    <StyledContainer>
      <TrackedLink
        trackingLabel=""
        trackingType={isMobile ? "mobile-logolink" : "desktop-logolink"}
        href={href}
        id={id}
        data-id={id}
        aria-label="Origin Energy My Account Page"
      >
        <OriginLogo />
      </TrackedLink>
    </StyledContainer>
  );
};

export default SmallerLogo;
